import React from 'react';
import ProjectContentContainer from "../../../components/ProjectContentContainer";
import {Grid, useMediaQuery, useTheme} from "@mui/material";
import {MoveToTopOnMount} from "../../../utils/pageScroll";
import Head from "../../../components/Head";
import './index.sass'
import engagementMap from "../../../assets/images/engagementMap.png";
import ProjectRecord from "../../../components/ProjectRecord";
import coverImg from "./book_cover1_thumb.png";
import book1Final from "./book_cover1_final.png";
import book1Invite from "./book_cover1_invite.png";
import book1Ok from "./book_cover1_ok.png";
import book1Classroom from "./book_cover1_classroom.png";
import book1School from "./book_cover1_school.png";
import book2 from "./book_cover2.png";
import book2Final from "./book_cover2_final.png";
import goHam from "../go_ham/go_ham_cover_bg.png";
import standUpReminder from "../stand_up_reminder/stand-up-cover-bg.png";

const GridContainerEngagementMap = ({children, sx}) => (
    <Grid container spacing={'2rem'} sx={sx}>
        {children}
    </Grid>
)

function Index({cursor}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <div>
            <Head
                title={'Book Covers'}
                desc={'Book covers designed by Eurey'}
            />
            <MoveToTopOnMount />

            <div className={`book_cover__cover ${isMobile && 'sur__cover_mobile'}`}>
                <img src={coverImg} alt={'draft version of the first book cover'} />
            </div>

            <ProjectContentContainer>
                <h1 className={'sur__title'}>
                    I designed 2 published book covers in Japan.
                </h1>

                <GridContainerEngagementMap sx={{marginBottom: '6rem'}}>
                    <Grid item xs={12}>
                        <h1>フル・インクルーシブ教育の実現にむけて - 大阪市立大空小学校の実践と今後の制度構築</h1>
                        <h2>The Development Process in Implementing Full Inclusive Education ― A case study of Ozora Elementary School in Osaka</h2>
                        <img src={book1Final} alt={'final version of the first book cover'} className={'sur__img'} />
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={4}>
                                <img src={book1Ok} alt={'hand holding a circle'} className={'sur__img'} />
                            </Grid>
                            <Grid item xs={4}>
                                <img src={book1Classroom} alt={'Japanese classroom'} className={'sur__img'} />
                            </Grid>
                            <Grid item xs={4}>
                                <img src={book1Invite} alt={'hand reaching into the middle of a circle'} className={'sur__img'} />
                            </Grid>
                        </Grid>
                    </Grid>
                </GridContainerEngagementMap>
            </ProjectContentContainer>

            <img src={book1School} alt={'school'} className={'sur__img'} />

            <ProjectContentContainer>
                <GridContainerEngagementMap sx={{marginTop: '4rem', marginBottom: '6rem'}}>
                    <Grid item xs={12}>
                        <h1>『犠牲のシステム』としての予防接種施策 - 日本における予防接種・ワクチン禍の歴史的変遷</h1>
                        <h2>The "Sacrificial System" in Vaccination Policies ー The History of Vaccines in Japan</h2>
                        <img src={book2} alt={'draft version of the second book cover'} className={'sur__img'} />
                    </Grid>
                </GridContainerEngagementMap>
            </ProjectContentContainer>

            <img src={book2Final} alt={'final version of the second book cover'} className={'sur__img'} />

            <ProjectContentContainer>
                {/*Other work*/}
                <GridContainerEngagementMap sx={{marginTop: '4rem', marginBottom: '6rem'}}>
                    <Grid item xs={12}>
                        <h1>Other Work</h1>

                        <Grid container spacing={'2rem'}>
                            <Grid item xs={12}>
                                <ProjectRecord
                                    to={'/work/GO-HAM'}
                                    title={'GO HAM!'}
                                    subtitle={'Re-establishing the Columbia community during COVID-19 through exercise'}
                                    desc={'Exercising app with emphasis on spontaneous human interaction through gamification. ' +
                                    'Helps motivate and keep students in a routine to exercise in a limited space with friends.'}
                                    img={goHam}
                                    imgAlt={'smart phone app design of go ham'}
                                    bgColor={'linear-gradient(127.67deg, rgba(17, 141, 255, 0.2) 60.94%, rgba(217, 242, 249, 0.2) 76.79%, rgba(255, 255, 255, 0.0252632) 92.97%), #D5FFCB'}
                                    cursor={cursor}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <ProjectRecord
                                    to={'/work/EngagementMap'}
                                    title={'EngagementMap'}
                                    subtitle={'A real-time, location-based, collective, and anonymous feedback system in the classroom'}
                                    desc={'Provides instructors with a glanceable spatial visualization of the classroom to help them understand ' +
                                    'how students are feeling.'}
                                    img={engagementMap}
                                    imgAlt={'smart phone app design of engagement map'}
                                    bgColor={'linear-gradient(127.67deg, rgba(253, 131, 255, 0.2) 60.94%, rgba(255, 139, 139, 0) 76.79%, rgba(255, 255, 255, 0.0252632) 92.97%), #ECF5FF'}
                                    cursor={cursor}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <ProjectRecord
                                    to={'/work/Alexa-Stand-Up-Reminder'}
                                    color={'dark'}
                                    title={'Alexa Stand Up Reminder'}
                                    subtitle={'Sitting for a long time has health concerns and we wanted to help you in a natural way'}
                                    desc={'Reminds you to stand up every 45 minutes and take a break for 5 minutes. During the break, it suggests  fun and relaxing activities!'}
                                    img={standUpReminder}
                                    imgAlt={'logo with alexa'}
                                    bgColor={'linear-gradient(114.74deg, rgba(0, 114, 255, 0.5) 56.88%, rgba(167, 125, 255, 0.265652) 97.5%, rgba(255, 255, 255, 0.0631579) 113.08%), #FF583B'}
                                    cursor={cursor}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </GridContainerEngagementMap>

            </ProjectContentContainer>

        </div>
    );
}

export default Index;